import { render, staticRenderFns } from "./apply5.vue?vue&type=template&id=386c73ff&scoped=true&"
import script from "./apply5.vue?vue&type=script&lang=js&"
export * from "./apply5.vue?vue&type=script&lang=js&"
import style0 from "./apply5.vue?vue&type=style&index=0&id=386c73ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c73ff",
  null
  
)

export default component.exports